import React from "react";
import { pumps, qhseBg } from "../../../../assets/images";
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const PumpsCompressors = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <SubOtherHero title="Pumps & Compressors" />
      </div>

      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex md:items-start md:justify-between gap-10 flex-col md:flex-row">
          {/* Left Text */}
          <div className="md:w-1/2">
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {t("Pumps & Compressors")}
            </p>

            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "We supply a wide range of industrial pumps and compressors designed for reliable performance in demanding environments. Our selection includes centrifugal pumps, screw compressors, piston compressors, diaphragm pumps, and more — suitable for applications in oil & gas, chemical, water treatment, and power generation industries."
              )}
            </p>

            <p className="mt-6 text-[20px] font-semibold text-[#141615]">
              {t("Key Features:")}
            </p>
            <ul className="mt-4 text-[14px] md:text-[20px] text-[#41444B] list-disc list-inside space-y-3">
              <li>{t("High efficiency and durability")}</li>
              <li>
                {t("Explosion-proof and corrosion-resistant models available")}
              </li>
              <li>
                {t(
                  "Suitable for high-pressure and high-temperature operations"
                )}
              </li>
              <li>{t("Available in various capacities and configurations")}</li>
              <li>
                {t(
                  "Compliant with API, ISO, and other international standards"
                )}
              </li>
            </ul>
          </div>

          {/* Right Image */}
          <div className="md:w-1/2 grid grid-cols-1 gap-4 mt-8 md:mt-0">
            <img
              src={pumps}
              alt="Drill Bit 1"
              className="w-full rounded-lg shadow-md"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PumpsCompressors;
